module.exports = __webpack_public_path__ + "static/media/adjuge-de.8a02b07a.png";